<div class="main-nav-container">
  <div class="search-container">
    <app-devsite-search (expandedChange)="onSearchActive($event)"></app-devsite-search>
  </div>
  @if (!searchIsActive) {
  <div class="-top-nav-container">
    <app-header-nav [menu]="menu"></app-header-nav>
  </div>
  <div class="quick-links-container">
    <span class="dark-mode-toggle">
      <a (click)="switchThemeMode()">
        <lucide-icon [name]="theme === 'light' ? 'moon' : 'sun'"></lucide-icon>
        Dark Mode
        <toggle-slide #toggleSlide [activeIndex]="theme === 'light' ? '0' : '1'"></toggle-slide>
      </a>
    </span>
    <div class="support-container">
      <span class="support" (click)="openParentMenu($event)">
        <app-link [to]="'/contact'"> <lucide-icon name="circle-question-mark"></lucide-icon> Help </app-link>
      </span>
    </div>
  </div>
  <div class="-bottom-nav-container">
    @if (!isUserLoggedIn) {
    <span class="user-login">
      <wpbutton to="/dashboard/login">Login</wpbutton>
    </span>
    } @if (isUserLoggedIn) {
    <user-account-dropdown [title]="userName" [subtitle]="userMail"></user-account-dropdown>
    }
  </div>
  }
</div>
